/* VELNA Somn — tap to enlarge a wide detail photograph on a phone.
   The closer-look object is roughly 2.07:1. On a portrait screen it can only
   ever render about 360px wide, which is a third of its desktop size, so the
   control panel and the piping stop being readable. This opens the same file
   scaled to the height of the screen inside a pannable frame, which is larger
   than the desktop rendering rather than smaller. No new imagery, no crop. */
(function () {
  'use strict';
  var D = document;
  var BP = 900;
  var TARGETS = ['.closer-product img'];
  var overlay = null;
  var lastFocus = null;

  function phone() {
    return window.matchMedia('(max-width:' + BP + 'px)').matches;
  }

  function styles() {
    if (D.getElementById('vs-zoom-style')) return;
    var s = D.createElement('style');
    s.id = 'vs-zoom-style';
    s.textContent = [
      '.vs-zoomable{position:relative;cursor:zoom-in}',
      '.vs-zoom-hint{position:absolute;right:12px;bottom:12px;z-index:4;',
      'display:inline-flex;align-items:center;gap:6px;padding:7px 11px;',
      'border-radius:999px;border:1px solid rgba(38,35,31,.14);',
      'background:rgba(246,241,232,.92);color:#4a443c;',
      'font:600 9px/1 Manrope,system-ui,sans-serif;letter-spacing:.13em;',
      'text-transform:uppercase;pointer-events:none}',
      '.vs-zoom-hint svg{width:11px;height:11px;flex:0 0 auto}',
      '@media(min-width:' + (BP + 1) + 'px){.vs-zoom-hint{display:none}',
      '.vs-zoomable{cursor:auto}}',
      '.vs-zoom{position:fixed;inset:0;z-index:99999;display:flex;',
      'flex-direction:column;background:#1a1815;opacity:0;',
      'transition:opacity .22s ease}',
      '.vs-zoom.is-open{opacity:1}',
      '.vs-zoom-bar{flex:0 0 auto;display:flex;align-items:center;',
      'justify-content:space-between;gap:12px;padding:14px 16px;color:#efe9df}',
      '.vs-zoom-bar p{margin:0;font:600 9px/1.4 Manrope,system-ui,sans-serif;',
      'letter-spacing:.15em;text-transform:uppercase;opacity:.68}',
      '.vs-zoom-close{appearance:none;border:1px solid rgba(239,233,223,.28);',
      'background:transparent;color:#efe9df;width:38px;height:38px;',
      'border-radius:50%;font-size:19px;line-height:1;cursor:pointer;',
      'display:grid;place-items:center}',
      '.vs-zoom-close:focus-visible{outline:2px solid #b69757;outline-offset:2px}',
      '.vs-zoom-frame{flex:1 1 auto;overflow-x:auto;overflow-y:hidden;',
      'display:flex;align-items:center;-webkit-overflow-scrolling:touch}',
      '.vs-zoom-frame::-webkit-scrollbar{height:0}',
      '.vs-zoom-frame img{height:74%;width:auto;max-width:none;display:block;',
      'margin:auto}',
      '.vs-zoom-foot{flex:0 0 auto;padding:0 16px 20px;text-align:center;',
      'color:#efe9df;font:400 11px/1.5 Manrope,system-ui,sans-serif;opacity:.6}',
      '@media(prefers-reduced-motion:reduce){.vs-zoom{transition:none}}'
    ].join('');
    D.head.appendChild(s);
  }

  function close() {
    if (!overlay) return;
    var node = overlay;
    overlay = null;
    node.classList.remove('is-open');
    D.documentElement.style.overflow = '';
    D.removeEventListener('keydown', onKey);
    window.setTimeout(function () {
      if (node.parentNode) node.parentNode.removeChild(node);
    }, 240);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
  }

  function open(img) {
    if (overlay) return;
    lastFocus = D.activeElement;
    var src = img.currentSrc || img.src;
    var node = D.createElement('div');
    node.className = 'vs-zoom';
    node.setAttribute('role', 'dialog');
    node.setAttribute('aria-modal', 'true');
    node.setAttribute('aria-label', img.alt || 'Enlarged photograph');
    node.innerHTML =
      '<div class="vs-zoom-bar"><p>Detail view</p>' +
      '<button type="button" class="vs-zoom-close" aria-label="Close">&times;</button></div>' +
      '<div class="vs-zoom-frame"><img src="' + src.replace(/"/g, '&quot;') +
      '" alt="' + String(img.alt || '').replace(/"/g, '&quot;') + '"></div>' +
      '<div class="vs-zoom-foot">Swipe sideways to follow the shape</div>';

    node.addEventListener('click', function (e) {
      if (e.target === node || e.target.closest('.vs-zoom-close')) close();
    });
    D.body.appendChild(node);
    D.documentElement.style.overflow = 'hidden';
    D.addEventListener('keydown', onKey);
    overlay = node;
    window.requestAnimationFrame(function () {
      node.classList.add('is-open');
      var frame = node.querySelector('.vs-zoom-frame');
      var pic = frame.querySelector('img');
      var centre = function () {
        frame.scrollLeft = (frame.scrollWidth - frame.clientWidth) / 2;
      };
      if (pic.complete) centre();
      else pic.addEventListener('load', centre);
      node.querySelector('.vs-zoom-close').focus();
    });
  }

  function hint() {
    var el = D.createElement('span');
    el.className = 'vs-zoom-hint';
    el.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<circle cx="11" cy="11" r="7"></circle><path d="M21 21l-4.3-4.3"></path>' +
      '<path d="M11 8v6M8 11h6"></path></svg><span>Tap to enlarge</span>';
    return el;
  }

  function wire() {
    styles();
    TARGETS.forEach(function (sel) {
      Array.prototype.forEach.call(D.querySelectorAll(sel), function (img) {
        var host = img.parentElement;
        if (!host || host.dataset.vsZoom === 'on') return;
        host.dataset.vsZoom = 'on';
        host.classList.add('vs-zoomable');
        host.appendChild(hint());
        host.addEventListener('click', function (e) {
          if (!phone()) return;
          e.preventDefault();
          open(img);
        });
      });
    });
  }

  if (D.readyState === 'loading') {
    D.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
})();
